import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const handleGoBack = () => {

        navigate(-1);
    };

    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>404 - Page Not Found</h1>
            <p>Oops! The page you are looking for does not exist.</p>
            <button onClick={handleGoBack} style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer', margin: '10px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '5px' }}>
                Go Back
            </button>
        </div>
    );
};

export default NotFoundPage;